<template>
  <div class="">
    <div  class="row ">
        <div class="inline_gameScreenNav col-3 noPad" href="#">
          <img href="#" v-if="showLogo" src="../assets/images/hor_loterialockup.8704f5e6.png" class="img-fluid sponsor" />
          <img href="#" v-if="showHashtag" src="../assets/images/hashtag_SPURS16.png" class="img-fluid" />
        </div>

        <div class="col-9 text-right" href="#" >
          <img href="#" v-if="showPresentedBy" src="../assets/images/PRESENTED BY_.png" class="img-fluid sponsor" />
          <div  class="inline_gameScreenNav inline_gameScreenNavBTN  menu-selectTransparent " width="50%" v-if="showHome" style="margin-left: 12px;"  href="#" @click="$emit('goHome')">{{homeButton[language]}}</div>
                    <div id="popover-1-topleft" 
          v-on:click="$emit('click')"  
          v-if="showRules"
          class="inline_gameScreenNav inline_gameScreenNavBTN  menu-selectDark " 
          width="50%"
          >{{rulesButton[language]}}</div>
          <div  class="inline_gameScreenNav inline_gameScreenNavBTN menu-selectDark"  width="50%"  href="#" v-if="showReset" @click="$emit('resetBoard')">{{shuffleButton[language]}}</div>
        </div>
        
  </div>
  <div  class="inline_gameScreenNav inline_gameScreenNavBTN  menu-selectTransparent " v-if="showRecentCards" style="margin-left: 0;float:left!important"  href="#" @click="$emit('showRecentCards')">{{historyButton[language]}}</div>
  <div  class="inline_gameScreenNav inline_gameScreenNavBTN  menu-selectTransparent " v-if="showRecentCards" style="margin-left: 0;float:right!important"  href="#" @click="$emit('resetBoard')">{{shuffleButton[language]}}</div>
          <b-popover custom-class="toolsHere"
            target="popover-1-topleft"
            placement="auto"
            triggers="click focus"
            content="Placement topleft"
            :show.sync="popover"
          >
            <div v-if="showDealerTut">
              <DealerTutorialView :language="language"/>
            </div>
            <div v-else>
              <PlayerTutorialView :language="language"/>
            </div>
          </b-popover>


    </div >
</template>
<script>
import PlayerTutorialView from './PlayerTutorialView'
import DealerTutorialView from './DealerTutorialView'

export default {
  name: "NavBar",
  components: {PlayerTutorialView, DealerTutorialView},
  props: ["useBoard", "showReset", "showPlay", 
          "showRules", "showPresentedBy", "showRulesBottom",
          "showLogo", "showHashtag", "showHome", "showRecentCards", 
          "showDealerTut", "showResetTwo", "language"],
  data(){
    return{
      popover: false,
      historyButton: {
        "english": "History",
        "spanish": "Historia"
      },
      rulesButton: {
        "english": "Rules",
        "spanish": "Reglas"
      },
      shuffleButton: {
        "english": "Shuffle",
        "spanish": "Barajar"
      },
      homeButton: {
        "english": "Home",
        "spanish": "Casa"
      }
    }
  },
  methods: {
    closePopover(){
      this.$root.$emit('bv::hide::popover')   
   }
  }
};
</script>
<style>
.bg-info {
  background-color: #ffffff !important;
}
</style>
